import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";

function TrafficViolationDocumentsListPageCardHeader({ trafficViolationData }) {
  const textColor = useColorModeValue("gray.700", "white");
  const { t } = useTranslation();

  const numero_ait = trafficViolationData?.numero_ait;
  const nome_proprietario_veiculo_ait = trafficViolationData?.nome_proprietario_veiculo_ait;
  const placa_veiculo = trafficViolationData?.placa_veiculo;
  const data_infracao = trafficViolationData?.data_infracao;
  const codigo_tipo_infracao = trafficViolationData?.codigo_tipo_infracao;
  const desdobramento_tipo_infracao = trafficViolationData?.desdobramento_tipo_infracao;
  const descricao_tipo_infracao = trafficViolationData?.descricao_tipo_infracao;

  return (
    <CardHeader px="22px" mb="24px">
      <Flex gap="1" direction="column">
        {numero_ait && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("traffic-violation.fields.ait-number")}:</strong> {numero_ait}
          </Text>
        )}
        {nome_proprietario_veiculo_ait && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("traffic-violation.fields.ait-vehicle-owner-name")}:</strong> {nome_proprietario_veiculo_ait}
          </Text>
        )}
        {placa_veiculo && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("traffic-violation.fields.vehicle-plate")}:</strong> {placa_veiculo}
          </Text>
        )}
        {data_infracao && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("traffic-violation.fields.infringement-date")}:</strong> {data_infracao}
          </Text>
        )}
        {(codigo_tipo_infracao || desdobramento_tipo_infracao || descricao_tipo_infracao) && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("traffic-violation.fields.infringement")}:</strong> {`${codigo_tipo_infracao ?? ""}-${desdobramento_tipo_infracao ?? ""} ${descricao_tipo_infracao ?? ""}`}
          </Text>
        )}
      </Flex>
    </CardHeader>
  );
}

export default TrafficViolationDocumentsListPageCardHeader;